
import { Component, Vue } from 'vue-property-decorator'
import { ElForm } from 'element-ui/types/form'
import { CommonService } from '@/services'
@Component({
    components: {}
})
export default class extends Vue {
    private loading = false
    private form = {
        name: ''
    }
    private rules = {
        name: [{ required: true, message: '请输入类型名称', trigger: 'blur' }]
    }
    get formRef() {
        return this.$refs.createTypeRef as ElForm
    }

    onConfirm() {
        this.formRef.validate(async valid => {
            if (valid) {
                this.loading = true
                const isCoolCompany = this.$route.name === 'ContentCoolCompanyTypeCreate'
                const name = isCoolCompany ? `酷公司/${this.form.name}` : this.form.name
                const result = await CommonService.createIArticleType({ name })
                if (result.status === 200) {
                    this.$msuccess('创建成功!')
                    const redirectPath = isCoolCompany ? '/content/coolcompany' : '/content/institute'
                    this.$router.push(redirectPath)

                }
                this.loading = false
            }
        })
    }
}
